import { render } from "./EditDocument.vue?vue&type=template&id=0630be5a"
import script from "./EditDocument.vue?vue&type=script&lang=js"
export * from "./EditDocument.vue?vue&type=script&lang=js"
script.render = render

export default script